<template>
  <base-row
    v-bind="$props"
    :selectable="false"
  >
    <td v-for="(value, keyName) in item">
      <Link
        v-if="getFieldLink(value)"
        :href="getFieldLink(value)"
      >
        {{ getFieldValue(value) }}
      </Link>
      <span v-else>
        {{ getFieldValue(value) }}
      </span>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _date from '@/Filters/Date'
import _percent from '@/Filters/Percent'
import _dollars from '@/Filters/Dollars'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {},

  computed: {},

  methods: {
    _date,
    _percent,
    _dollars,

    getFieldValue(val) {
      if (typeof val === 'object' && val) {
        return val.value
      }

      return val
    },
    getFieldLink(val) {
      if (typeof val === 'object' && val) {
        return val.url
      }

      return null
    }
  }
}
</script>
